export const sportsDict = {
  'nfl': 'Football',
  'mlb': 'Baseball',
  'all': 'All Sports'
};
